import { ref, type ComputedRef } from 'vue';
import type { ListingFilter } from '@shopware-pwa/types';

// Global cache (shared across components)
let initialized = false;
const cachedInitialFilters = ref<ListingFilter[]>([]);
const cachedCurrentFilters = ref<ListingFilter[]>([]);

export const useListingFilters = () => {
  const initializeFilters = (
    initialFilters: ComputedRef<ListingFilter[]>,
    currentFilters: ComputedRef<ListingFilter[]>,
  ) => {
    if (initialized) return;

    cachedInitialFilters.value = initialFilters.value;
    cachedCurrentFilters.value = currentFilters.value;
    initialized = true;
  };

  return {
    initializeFilters,
    initialFilters: cachedInitialFilters,
    currentFilters: cachedCurrentFilters,
    isFiltersInitialized: () => initialized,
  };
};
